import LayoutContainer from "../../../components/Containers/LayoutContainer"
import '@fortawesome/fontawesome-free/css/all.min.css';
import React from "react"
import "./livingResponsibility.scss";


const LivingResponsibility: React.FunctionComponent = () => {

    return (
      <LayoutContainer title="living-responsibility">
        <div className=" page-header d-flex align-items-center justify-content-left dashboard-container h-100">
         <h2>
          <i className="page-header-icon fa fa-home">
            
          </i>
          Living Responsibility
         </h2>
  
        </div>
      </LayoutContainer>
    );
  };
  

export default LivingResponsibility;